import {
  ExportListItem,
  ExportType,
  ExportTypeUnion,
  FilterLabelWithId,
} from "types/exports";
import { FilterBe, SelectedFilter } from "types/filters";
import { redemptionCodesFilterLabelsList } from "../Campaign/Direct/CampaignRedemptionCodes/helpers";
import { memberFilterLabelsList } from "../Member/MemberList/helpers";
import { rewardFulfillmentFilterLabelsList } from "../Reward/RewardFulfillmentList/helpers";

const getFilterListByType = (type: ExportTypeUnion) => {
  let filterList: FilterLabelWithId[] = [];

  switch (type) {
    case ExportType.MEMBER:
      filterList = memberFilterLabelsList;
      break;
    case ExportType.CAMPAIGN_CODE:
      filterList = redemptionCodesFilterLabelsList;
      break;
    case ExportType.REWARD_FULFILLMENT:
      filterList = rewardFulfillmentFilterLabelsList;
      break;
    default:
      filterList = [];
  }

  return filterList;
};

export const filterIsShown = (key: string, type: ExportTypeUnion) =>
  getFilterListByType(type)
    .map((filter) => filter.id)
    .includes(key);

export const getFilterLabel = (item: ExportListItem, key: string) =>
  getFilterListByType(item.type).filter((label) => label.id === key)[0]?.label;

export const parseFiltersForExport = (
  filters: (SelectedFilter | FilterBe)[],
) => {
  const result: Record<string, any> = {};

  for (const filter of filters) {
    if (filter.condition) {
      result[filter.query] = {
        [filter.condition]: filter.value,
      };
    } else {
      result[filter.query] = filter.value;
    }
  }
  return result;
};
